export interface IPV_FORMULA {
  futureValue: number | undefined;
  rateOfInterest: number | undefined;
  numberOfPeriod: number | undefined;
}

export const PRESENT_VALUE_FORMULA = ({
  futureValue,
  rateOfInterest,
  numberOfPeriod,
}: IPV_FORMULA) => {
  if (
    !futureValue ||
    !rateOfInterest ||
    !numberOfPeriod ||
    futureValue < 0 ||
    rateOfInterest < 0 ||
    numberOfPeriod < 0
  ) {
    return {
      presentValueOfInvestment: 0,
      totalInterest: 0,
    };
  }

  const presentValueOfInvestment =
    futureValue / Math.pow(1 + rateOfInterest / 100, numberOfPeriod);
  const totalInterest = futureValue - presentValueOfInvestment;

  return { presentValueOfInvestment, totalInterest };
};
